import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  ApplicationState,
  getAllDeepLinkProducts,
  getBizzGuestWifi,
  getDeepLinkSelectedProduct,
  getOptionsCategoriesConfig,
  getSelectedProductDetails,
  getSettingsCategoriesConfig,
  getUserProduct,
} from '../../store/reducers';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import {
  DeepLinkData,
  DeepLinkStatus,
  getDeepLinkData,
  getFavoriteContentWithHighestRank,
  getMprdProductType,
  getOptionForGivenProduct,
  InternetProduct,
  isMpayFormVisible,
  isNetflixBuyAndSell,
  isOptionActive,
  MobileProduct,
  NetflixBuyAndSellStatus,
  Option,
  OptionStatus,
  OptionType,
  Pack,
  PdaResponseModel,
  PlcCodes,
  Product,
  TvProduct,
} from '@dch/products-business-logic';
import {
  GetDeepLinkOptionDetails,
  GetEBUProductDetails,
  GetProductDetails,
} from '../../store/actions/product-details.actions';
import {
  GetOptionsCategoriesConfig,
  GetSettingsCategoriesConfig,
} from '../../store/actions/magnolia-config.actions';
import {
  AnalyticsService,
  CustomerService,
  EnvironmentService,
  InceptionService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import {
  AlertsService,
  ModalService,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import { CustomerAccount } from '@proximus/common-business-logic';
import { OptionDetailsBaseComponent } from './option-details-base/option-details-base.component';
import { Location } from '@angular/common';
import {
  getPiiBrand,
  getPiiServiceId,
  savePii,
} from '../../shared/pii/pii.utils';
import { EwebTokenService } from '../../services/eweb-token.service';
import * as ProductsActions from '../../store/actions/products.actions';
import * as MagnoliaConfigActions from '../../store/actions/magnolia-config.actions';
import { DetailsUtilService } from '../details-service.utils';
import { isMpcuidBlacklisted } from '../../overview/util/overview-util';

@Component({
  selector: 'mprd-option-details',
  templateUrl: './option-details.component.html',
})
export class OptionDetailsComponent
  extends OptionDetailsBaseComponent
  implements OnInit
{
  OptionType = OptionType;
  PlcCodes = PlcCodes;
  OptionStatus = OptionStatus;
  NetflixBuyAndSellStatus = NetflixBuyAndSellStatus;
  MPAY_MPCUUID = 'DNSND';

  selectedProduct: MobileProduct | InternetProduct | TvProduct | Product;
  pendingOrder = false;
  deepLinkStatus: DeepLinkStatus;
  isDeepLinkDataLoaded: boolean;
  isDeepLinkDifferentOptionPrice: boolean;
  isDeepLinkCheapestOptionFree: boolean;
  isStartingFromPriceVisible: boolean;
  isDeepLinkFootNoteVisible: boolean;
  isFreeAsteriksVisible: boolean;
  productTypeParameter: string;
  internalSsid: string;
  hasInvolvement: boolean;

  private isFlsAu: boolean;
  private isDeepLinkMultipleEligibleProducts: boolean;
  private readonly eshareOptionFlowMpcuidBlacklist = this.translationService.getTranslatedValueFor(
    'eshare.optionFlow.mpcuidBlacklist',
  );
  private readonly currentOptionMpcuid = this.activatedRoute.snapshot.params['mpcUuid'];
  isEshareTvOptionFlowEnabled = this.translationService.getTranslatedValueFor(
    'eshare.tv.enableOptionFlowRedirect',
  ) === 'true' && this.activatedRoute.snapshot.queryParams['old'] !== 'true'
    && !isMpcuidBlacklisted(this.currentOptionMpcuid, this.eshareOptionFlowMpcuidBlacklist);
  isEshareMobileOptionFlowEnabled = this.translationService.getTranslatedValueFor(
    'eshare.mobile.enableOptionFlowRedirect',
  ) === 'true' && !isMpcuidBlacklisted(this.currentOptionMpcuid, this.eshareOptionFlowMpcuidBlacklist);

  isEshareNimbleMobileOptionFlowEnabled = this.translationService.getTranslatedValueFor(
    'eshare.mobile.enableNimbleOptionFlowRedirect',
  ) === 'true' && !isMpcuidBlacklisted(this.currentOptionMpcuid, this.eshareOptionFlowMpcuidBlacklist);

  isNimbleEnabled = this.translationService.getTranslatedValueFor(
    'nimble.enable',
  ) === 'true';

  private readonly nimbleMpcUuids: string[] = (
    this.translationService.getTranslatedValueFor('nimble.mpcUuids') || ''
  )
    .split(',')
    .map((s: string) => s.trim())
    .filter((s: string) => !!s);

  hideCeaseButton: boolean;
  isNetflixBuyAndSellOption: boolean;
  isDiscountTextVisible: boolean;
  flexPackDiscountText: string;
  isOnTopCurrentPackVisible: boolean;
  netflixBuyAndSellStatus: NetflixBuyAndSellStatus;
  treatmentCode: string;
  isConfigurableOption: boolean;
  isMpay: boolean;
  isSmoothAccess: boolean;
  isEBU: boolean;
  queryParamToken: string;
  tokenEndPhoneNumber: any;
  tokenMpcUuid: any;
  isNimbleRedirection: boolean;
  isNimbleResolutionPending = false;
  showNimbleIneligibleAlert = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<ApplicationState>,
    languageService: LanguageService,
    alertService: AlertsService,
    customerService: CustomerService,
    private ref: ChangeDetectorRef,
    private cdRef: ChangeDetectorRef,
    translationService: TranslationService,
    protected inceptionService: InceptionService,
    location: Location,
    modalService: ModalService,
    analyticsService: AnalyticsService,
    pxModalMessageService: PxModalMessageService,
    environmentService: EnvironmentService,
    private router: Router,
    private readonly ewebTokenService: EwebTokenService,
    private readonly _store: Store<ApplicationState>,
    private readonly detailsUtilService: DetailsUtilService,
  ) {
    super(
      translationService,
      languageService,
      alertService,
      customerService,
      location,
      modalService,
      pxModalMessageService,
      analyticsService,
      environmentService,
    );
  }

  ngOnInit() {
    if (!this.isSmoothAccess) {
      if (this.isEshareTvOptionFlowEnabled || this.isEshareMobileOptionFlowEnabled || this.isEshareNimbleMobileOptionFlowEnabled) {
        this.getProducts();
      }

      this.addSubscription(
        combineLatest([
          this.activatedRoute.params,
          this.customerService.getCustomerAccount(),
        ]).subscribe((res) => {
          const params = res[0];
          const customerAccount = res[1];
          if (params['deepLinkMpcUuid']) {
            this.deepLinkMpcUuid = params['deepLinkMpcUuid'];
            this.store.dispatch(
              new GetDeepLinkOptionDetails(params['deepLinkMpcUuid']),
            );
          } else if (params['mpcUuid'] && params['mpcUuid'].indexOf('-') > -1) {
            [this.tokenEndPhoneNumber, this.tokenMpcUuid] = params['mpcUuid'].split('-');
            if (!this.isNimbleEnabled || (this.nimbleMpcUuids.length > 0 && !this.nimbleMpcUuids.includes(this.tokenMpcUuid))) {
              this.routeToOverview();
              return;
            }
            this.isNimbleRedirection = true;
            this.isNimbleResolutionPending = true;
            this.fetchFullMsisdnByPhoneNumberSuffix(params['productType'], this.tokenEndPhoneNumber);
          }
          const serviceId = getPiiServiceId();
          if (serviceId && params['productType']) {
            this.productTypeParameter = params['productType'];
            if (customerAccount) {
              this.isFlsAu =
                customerAccount.flsDefaultCustomer &&
                customerAccount.flsDefaultCustomer.payer;
              this.isEBU = customerAccount.isEBU();
              if (this.isEBU) {
                this.store.dispatch(
                  new GetEBUProductDetails({
                    productType: 'mobile',
                    serviceId,
                  }),
                );
              } else if (!this.isNimbleRedirection) {
                const isNotFullControlBrand = getPiiBrand() != 'bonefullcontrol';
                this.store.dispatch(
                  new GetProductDetails({
                    productType: params['productType'],
                    serviceId,
                    isNotFullControlBrand,
                  }),
                );
              }
            }
          }
        }),
      );
      this.addSubscription(
        this.activatedRoute.queryParams.subscribe((params: any) => {
          this.treatmentCode = params['treatmentCode'];
        }),
      );
      this.store.dispatch(new GetOptionsCategoriesConfig());
      this.store.dispatch(new GetSettingsCategoriesConfig());

      this.addSubscription(
        combineLatest([
          this.activatedRoute.params,
          this.activatedRoute.queryParams,
          this.store.select(getSelectedProductDetails),
          this.store.select(getOptionsCategoriesConfig),
          this.customerService.getCustomerAccount(),
          this.store.select(getSettingsCategoriesConfig),
          this.store.select(getAllDeepLinkProducts),
          this.store.select(getBizzGuestWifi),
          this.store.select(getDeepLinkSelectedProduct),
        ]).subscribe(
          (
            res: [
              Params,
              Params,
              PdaResponseModel,
              any,
              CustomerAccount,
              any,
              Array<MobileProduct | InternetProduct | TvProduct>,
              any,
              Product,
            ],
          ) => {
            const params = res[0];
            const queryParams = res[1];
            const selectedProduct = res[2];
            const optionsConfig = res[3];
            const customerAccount = res[4];
            const settingsConfig = res[5];
            const deepLinkProducts = res[6];
            const bizzGuestWifi = res[7];
            const selectedDeepLinkProduct = res[8];

            const optionMpcUuid = this.getOptionMpcUuid(params);

            if (
              params['deepLinkMpcUuid'] &&
              deepLinkProducts &&
              optionsConfig &&
              settingsConfig
            ) {
              this.isDeepLinkDataLoaded = true;
              const deepLinkData = getDeepLinkData(
                deepLinkProducts,
                optionMpcUuid,
                optionsConfig,
                settingsConfig,
                this.languageService.getSelectedLanguage(),
                customerAccount,
              );
              this.deepLinkStatus = deepLinkData.deepLinkStatus;
              this.selectedProduct =
                deepLinkData.selectedProduct || selectedDeepLinkProduct;
              this.option = deepLinkData.option;
              this.productType = deepLinkData.productType;
              this.isDeepLinkDifferentOptionPrice =
                deepLinkData.isDeepLinkDifferentOptionPrice;
              this.isDeepLinkCheapestOptionFree =
                deepLinkData.isDeepLinkCheapestOptionFree;
              this.isStartingFromPriceVisible =
                deepLinkData.isStartingFromPriceVisible;
              this.isDeepLinkFootNoteVisible =
                deepLinkData.isDeepLinkFootNoteVisible;
              this.isFreeAsteriksVisible = deepLinkData.isFreeAsteriksVisible;
              this.isDeepLinkMultipleEligibleProducts =
                this.deepLinkStatus ===
                DeepLinkStatus.DEEPLINK_SEVERAL_PRODUCTS_ELIGIBLE;
              this.handleDeeplinkProductStatus(deepLinkData, deepLinkProducts);
            } else if (
              optionMpcUuid &&
              selectedProduct &&
              optionsConfig &&
              settingsConfig
            ) {
              if (
                (selectedProduct &&
                  selectedProduct.mobileProductDetails &&
                  selectedProduct.mobileProductDetails.options) ||
                (selectedProduct.tvProductDetails &&
                  selectedProduct.tvProductDetails.options) ||
                (selectedProduct.internetProductDetails &&
                  selectedProduct.internetProductDetails.options) ||
                (selectedProduct.digitalisProductDetails &&
                  selectedProduct.digitalisProductDetails.options) ||
                (selectedProduct.telephonyProductDetails &&
                  selectedProduct.telephonyProductDetails.options)
              ) {
                this.selectedProduct =
                  selectedProduct.mobileProductDetails ||
                  selectedProduct.tvProductDetails ||
                  selectedProduct.internetProductDetails ||
                  selectedProduct.digitalisProductDetails ||
                  selectedProduct.telephonyProductDetails;
                this.productType = getMprdProductType(this.selectedProduct);
                this.option = getOptionForGivenProduct(
                  this.selectedProduct,
                  optionMpcUuid,
                  optionsConfig,
                  settingsConfig,
                  this.languageService.getSelectedLanguage(),
                );
                this.isConfigurableOption = this.checkIfConfigurableOption();
                this.isMpay = this.checkIfMpay();
              }
            }
            if (bizzGuestWifi.data) {
              this.internalSsid = bizzGuestWifi.data.internalSsid;
              this.hasInvolvement = bizzGuestWifi.data.hasInvolvement;
            }

            if (
              this.isNimbleRedirection &&
              optionMpcUuid &&
              selectedProduct &&
              optionsConfig &&
              settingsConfig
            ) {
              this.isNimbleResolutionPending = false;
              this.showNimbleIneligibleAlert = !this.option;
            } else {
              this.showNimbleIneligibleAlert = false;
            }

            this.handleEshareOptionFlowRedirect();

            this.isNetflixBuyAndSellOption = isNetflixBuyAndSell(this.option);
            this.hasWebdeals();
            this.getWebdealSuffix();
            this.setOptionName();
            this.setOptionDescriptionName();
            this.setDiscountTextVisible();
            this.setOnTopCurrentPackVisible();
            this.setNetflixBuyAndSellStatus();
            this.reportCardImpressionTaggingEvent();
          },
        ),
      );
    } else {
      this.addSubscription(
        this.store
          .select(getSelectedProductDetails)
          .subscribe((selectedProduct) => {
            if (
              selectedProduct.tvProductDetails &&
              selectedProduct.tvProductDetails.options
            ) {
              this.selectedProduct = selectedProduct.tvProductDetails;

              this.option = getOptionForGivenProduct(
                this.selectedProduct,
                this.getDisneyPlusOptionMpcUuid(this.selectedProduct),
                {},
                {},
                this.languageService.getSelectedLanguage(),
              );
              this.setOptionName();
              this.setOptionDescriptionName();
              this.isDeepLinkDataLoaded = true;
              this.productType = getMprdProductType(this.selectedProduct);
              savePii(this.selectedProduct.accessNumber);
            }
          }),
      );
      this.addSubscription(
        this.activatedRoute.queryParams.subscribe((queryParams) => {
          if (queryParams['token']) {
            this.queryParamToken = queryParams['token'];
          }
        }),
      );
    }
    if (this.option?.ibStatus === OptionStatus.ERROR) {
      this.sendStatusToReactNativeWebView({
        action: 'ORDER_CANCELLED',
        reason: 'option status is error ',
        data: OptionStatus.ERROR,
      });
    }
    this.scrollToTop();
    this.inceptionService.init();
  }

  get isMobileOptionEshareRedirectActive(): boolean {
    return (
      this.productType === 'mobile' &&
      (this.isNimbleRedirection
        ? this.isEshareNimbleMobileOptionFlowEnabled
        : this.isEshareMobileOptionFlowEnabled)
    );
  }

  private handleEshareOptionFlowRedirect(): void {
    if (this.productType === 'tv' && this.isEshareTvOptionFlowEnabled) {
      this.addSubscription(this.ewebTokenService.getRedirectToEshareOptionFlowUrl(
        PlcCodes.TV,
        this.deepLinkMpcUuid
      ).subscribe((redirectUrl: string) => {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      }));
    }

    if (
      this.productType === 'mobile' &&
      (this.isNimbleRedirection
        ? this.isEshareNimbleMobileOptionFlowEnabled
        : this.isEshareMobileOptionFlowEnabled)
    ) {
      // For the nimble (4digitMV-optionMpcUuid) flow, the serviceId has already been
      // resolved from the 4-digit MSISDN suffix and persisted via savePii(). Pass it
      // to add the matching serviceId into the JWT eweb token, and keep the option
      // MpcUuid (tokenMpcUuid) in the eShare redirection URL. For the nimble flow we
      // also flag the redirect with aiFlow=true.
      const mpcUuid = this.isNimbleRedirection
        ? this.tokenMpcUuid
        : this.deepLinkMpcUuid;
      const serviceId = this.isNimbleRedirection ? getPiiServiceId() : undefined;
      this.addSubscription(this.ewebTokenService.getRedirectToEshareOptionFlowUrl(
        PlcCodes.MV,
        mpcUuid,
        serviceId,
        this.isNimbleRedirection,
      ).subscribe((redirectUrl: string) => {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      }));
    }
  }

  private handleDeeplinkProductStatus(
    deepLinkData: DeepLinkData,
    deepLinkProducts?: Array<MobileProduct | InternetProduct | TvProduct>,
  ) {
    switch (deepLinkData.deepLinkStatus) {
      case DeepLinkStatus.DEEPLINK_NO_PRODUCTS:
        this.router.navigate(['/overview']);
        break;
      case DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE:
        this.dispatchAlert(
          'error',
          this.translationService.getTranslatedValueFor(
            'option.deeplink.incompatible.title',
          ),
          this.translationService.getTranslatedValueFor(
            'option.deeplink.incompatible.message',
          ),
        );
        break;
      case DeepLinkStatus.DEEPLINK_OPTION_ORDERING_ALREADY_ACTIVE:
        this.dispatchAlert(
          'info',
          this.translationService.getTranslatedValueFor(
            'option.deeplink.alreadyActive.title',
          ),
          this.translationService.getTranslatedValueFor(
            'option.deeplink.alreadyActive.message',
          ),
        );
        break;
      case DeepLinkStatus.DEEPLINK_SEVERAL_PRODUCTS_ELIGIBLE:
        if (!this.isProductCompatibility(deepLinkProducts)) {
          this.router.navigate(['/overview']);
        }
        break;
      default:
        break;
    }
  }

  private getOptionMpcUuid(params: Params) {
    if (params['mpcUuid'] && params['mpcUuid'].indexOf('-') > -1) {
      return this.tokenMpcUuid;
    }

    return params['mpcUuid'] ? params['mpcUuid'] : params['deepLinkMpcUuid'];
  }

  private getDisneyPlusOptionMpcUuid(selectedProduct: any) {
    return selectedProduct?.options?.find(
      (option) => isOptionActive(option) && this.isDisneyPlusOption(option),
    )?.optionCodeForDescription;
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#option-details');
    });
  }

  showMpayForm() {
    return isMpayFormVisible(this.selectedProduct, this.option, this.isFlsAu);
  }

  isOptionIncluded(includedOption: boolean) {
    this.hideCeaseButton = !includedOption;
    this.cdRef.detectChanges();
  }

  setDiscountTextVisible() {
    if (this.selectedProduct) {
      const favContent: Option = getFavoriteContentWithHighestRank(
        this.selectedProduct,
      );
      this.isDiscountTextVisible =
        this.isNetflixBuyAndSellOption &&
        (!favContent || isNetflixBuyAndSell(favContent));
      this.flexPackDiscountText =
        this.option && this.option.favContentMessage !== undefined
          ? this.option.favContentMessage[
              this.languageService.getSelectedLanguage() || 'en'
            ]
          : undefined;
    } else {
      this.isDiscountTextVisible = false;
      this.flexPackDiscountText = undefined;
    }
  }

  public isBizzGuestWifiOption() {
    return this.option && this.option.optionCodeForDescription === 'KKUDU';
  }

  public buildRedirectURL() {
    const url =
      this.option?.redirectLink?.url[
        this.languageService.getSelectedLanguage()
      ];
    if (this.isBizzGuestWifiOption() && this.isActiveOption()) {
      return url.concat('?id=' + this.internalSsid);
    }
    return url;
  }

  setOnTopCurrentPackVisible() {
    this.isOnTopCurrentPackVisible =
      this.selectedProduct &&
      (this.selectedProduct as TvProduct).netflixBuyAndSell ===
        NetflixBuyAndSellStatus.AVAILABLE &&
      this.isNetflixBuyAndSellOption;
  }

  setNetflixBuyAndSellStatus() {
    this.netflixBuyAndSellStatus =
      this.selectedProduct &&
      (this.selectedProduct as TvProduct).netflixBuyAndSell;
  }

  checkIfConfigurableOption() {
    return (
      this.selectedProduct &&
      this.selectedProduct.configurableOptions &&
      !!this.selectedProduct.configurableOptions.find(
        (option) =>
          this.option.optionCodeForDescription ===
          option.optionCodeForDescription,
      )
    );
  }

  checkIfMpay() {
    return (
      this.option && this.option.optionCodeForDescription === this.MPAY_MPCUUID
    );
  }

  private isProductCompatibility(
    deepLinkProducts?: Array<MobileProduct | InternetProduct | TvProduct>,
  ): boolean {
    return (
      deepLinkProducts &&
      !!deepLinkProducts.find(
        (product) =>
          product.deepLinkStatus &&
          product.deepLinkStatus !==
            DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE,
      )
    );
  }

  private getProducts() {
    const appBrand = this.translationService.getTranslatedValueFor('app.brand');
    this._store.dispatch(
      new ProductsActions.GetProducts({
        appBrand: appBrand || 'proximus',
      }),
    );
    this._store.dispatch(new MagnoliaConfigActions.GetOptionGroupsConfig())
  }

  private fetchFullMsisdnByPhoneNumberSuffix(type: string, endPhoneNumber: string): void {
    this.store.dispatch(new ProductsActions.GetProducts());
    this.tokenEndPhoneNumber = endPhoneNumber;
    this.addSubscription(
      this.store
        .select(getUserProduct)
        .pipe(filter((userProduct) => !!userProduct?.loaded), take(1))
        .subscribe((userProduct) => {
          const packs: Pack[] = userProduct.packs || [];
          const outOfPacks: Pack[] = userProduct.outOfPacks || [];

          if (
            this.tokenEndPhoneNumber &&
            ((packs && packs.length > 0) ||
              (outOfPacks && outOfPacks.length > 0))
          ) {
            const productsAvailableForMsisdn = this.detailsUtilService.filterMobileProducts(
              packs,
              outOfPacks,
              [PlcCodes.MV],
              this.tokenEndPhoneNumber,
            );

            if (
              !productsAvailableForMsisdn ||
              productsAvailableForMsisdn.length !== 1
            ) {
              if (!productsAvailableForMsisdn || productsAvailableForMsisdn.length === 0) {
                this.sendStatusToReactNativeWebView({ action:"ORDER_CANCELLED", reason: 'No products found for msisdn ', msisdn: this.tokenEndPhoneNumber });
              } else {
                this.sendStatusToReactNativeWebView({ action:"ORDER_CANCELLED", reason: 'Multiple products found for msisdn ', msisdn: this.tokenEndPhoneNumber });
              }

              this.routeToOverview();
            } else {
              const serviceId = productsAvailableForMsisdn[0].accessNumber;
              savePii(serviceId);

              const isNotFullControlBrand = getPiiBrand() != 'bonefullcontrol';
                this.store.dispatch(
                  new GetProductDetails({
                    productType: type,
                    serviceId,
                    isNotFullControlBrand,
                  }),
                );
            }
          } else {
            this.routeToOverview();
          }
        }),
    );
  }

  private sendStatusToReactNativeWebView(details: any): void {
    if (!this.isNimbleRedirection) {
      return;
    }

    const reactNativeWebView = (window as any).ReactNativeWebView;
    if (reactNativeWebView) {
      reactNativeWebView.postMessage(JSON.stringify(details));
    }
  }

  private routeToOverview() {
    this.router.navigate(['/overview']);
  }
}
